import { type QueryObserverOptions, useQuery } from '@tanstack/react-query';

import FunctionKey from 'constants/functionKey';
import { useGetTokens } from 'libs/tokens';
import { useAccountAddress, useChainId } from 'libs/wallet';
import type { ChainId } from 'types';
import type { Address } from 'viem';
import { type GetLiquidityHubInput, type GetLiquidityHubOutput, getLiquidityHub } from '..';

export type UseGetLiquidityHubInput = {
  vhTokenAddress: Address;
};

export type UseGetLiquidityHubQueryKey = [
  FunctionKey.GET_LIQUIDITY_HUB,
  UseGetLiquidityHubInput & { chainId: ChainId; accountAddress?: Address },
];

type Options = QueryObserverOptions<
  GetLiquidityHubOutput,
  Error,
  GetLiquidityHubOutput,
  GetLiquidityHubOutput,
  UseGetLiquidityHubQueryKey
>;

export const useGetLiquidityHub = (input: UseGetLiquidityHubInput, options?: Partial<Options>) => {
  const { chainId } = useChainId();
  const { accountAddress } = useAccountAddress();
  const tokens = useGetTokens({ chainId });
  const queryInput: GetLiquidityHubInput = {
    chainId,
    accountAddress,
    tokens,
    vhTokenAddress: input.vhTokenAddress,
  };

  return useQuery({
    queryKey: [
      FunctionKey.GET_LIQUIDITY_HUB,
      { chainId, accountAddress, vhTokenAddress: input.vhTokenAddress },
    ],
    queryFn: () => getLiquidityHub(queryInput),
    ...options,
  });
};
